import React, { useEffect } from 'react';
import { LoginProps } from './props';

const LoginRedirect: React.FC<LoginProps> = ({ }: LoginProps): React.ReactElement => {
  const redirect = async () => {
    setTimeout(function () {
      window.location.href='/login';
    }, 1000);
  };

  useEffect(() => {
    redirect();
  },[]);

  return (
    <>
    </>
  );
};

export default LoginRedirect;